module.exports = __webpack_public_path__ + "static/media/outbound-phone.7427d388.png";